// As cartas em destaque da faixa da página inicial (míticas, uma por tema). Ficheiro mínimo: a página inicial
// não carrega o catálogo completo (152 cartas), que só a página das cartas precisa.
export const FEATURED_CARDS: { id: string; name: { pt: string; en: string } }[] = [
  { id: "ALV-016", name: { pt: "Solaris, o Sol Desperto", en: "Solaris, the Woken Sun" } },
  { id: "ECO-016", name: { pt: "Aelis, Marca do Sol", en: "Aelis, Mark of the Sun" } },
  { id: "ECO-100", name: { pt: "O Astrolábio Partido", en: "The Broken Astrolabe" } },
  { id: "ECO-032", name: { pt: "Rainha Morwen", en: "Queen Morwen" } },
  { id: "ALV-032", name: { pt: "Noctra, a Lua Faminta", en: "Noctra, the Hungry Moon" } },
];
